import { useLang } from 'hooks/lang';

import { Drawer, DropdownMenu, IconButton, ResponsiveRender } from 'components/Blocks';
import { HorizontalDotsIcon } from 'components/Icons';

// Only these actions will work properly
// always import them to enable, watch for other on possible errors
import './ExcludedIds';
import './SampleIds';
import './SampleProjects';
import './CreateSampleProject';
import './RequestRecruitment';
import './AnswerDateChangeRequest';
import './CancelTask';
import './RequestDateChange';
import './OwnershipChange';

import { TaskOptionModal } from './Modal';

import { TaskOptionGroup } from './OptionGroup';
import { EnabledTaskOptionsGuard } from './EnabledGuard';

export function TaskOptions({ task }: { task: { id: string; name: string } }) {
  const { t } = useLang();

  return (
    <EnabledTaskOptionsGuard taskId={task.id}>
      {({ options, safeList }) => {
        const sampleOptions = safeList([
          'CREATE_SAMPLE_PROJECT',
          'SAMPLE_PROJECTS',
          'EXCLUDED_IDS',
          'SAMPLE_PROJECT_IDS',
        ]);

        const recruitmentOptions = safeList(['REQUEST_RECRUITMENT']);

        const items = (
          <>
            <TaskOptionGroup title="Sample" taskId={task.id} options={sampleOptions} />

            <TaskOptionGroup
              title={t('recruitment')}
              options={recruitmentOptions}
              taskId={task.id}
              addDivisor={!!sampleOptions.length}
            />

            <TaskOptionGroup
              title={t('change')}
              addDivisor={!!sampleOptions.length || !!recruitmentOptions.length}
              options={safeList([
                'CHANGE_OWNER',
                'CHANGE_SUB_OWNER',
                'REMOVE_SUB_OWNER',
                'REQUEST_DATE_CHANGE',
                'ANSWER_DATE_CHANGE',
              ])}
              taskId={task.id}
            />

            <TaskOptionGroup
              options={safeList(['CANCEL_TASK'])}
              taskId={task.id}
              addDivisor={options.length > 1}
            />
          </>
        );

        return (
          <>
            <TaskOptionModal taskId={task.id} />

            <ResponsiveRender
              defaultContent={
                <DropdownMenu
                  tooltipContent={t('task-options')}
                  align="end"
                  disabled={!options.length}
                  className="min-w-60"
                >
                  {items}
                </DropdownMenu>
              }
              responsiveContent={
                <Drawer
                  title={task.name}
                  className="max-h-[80vh] overflow-y-auto"
                  gap="2"
                  trigger={
                    <IconButton size="small" disabled={!options.length}>
                      <HorizontalDotsIcon />
                    </IconButton>
                  }
                >
                  {items}
                </Drawer>
              }
            />
          </>
        );
      }}
    </EnabledTaskOptionsGuard>
  );
}
